import { ChevronDown } from "lucide-react";
import React from "react";

export default function MyDropList2({
  label,
  options = [],
  value,
  onChange,
  placeholder,
  className = "",
  error,
  disabled = false,
}) {
  return (
    <div className={`space-x-2  ${className}`}>
      {label && (
        <label className="block whitespace-nowrap  text-md font-medium tracking-wider text-slate-700 dark:text-slate-300">
          {label}
        </label>
      )}

      <div className="relative w-full ">
        <select
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          className="  appearance-none
      w-full
      text-xs
      py-2.5
      pl-4
      pr-8
      bg-slate-400/20
      dark:bg-slate-800
      border border-slate-200
      dark:border-slate-700
      rounded-md
      text-slate-800
      dark:text-white
      focus:outline-none
      focus:ring-2
      focus:ring-blue-500
      transition-all"
        >
          {placeholder && <option value="">{placeholder}</option>}

          {options.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <ChevronDown
          size={16}
          className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-500"
        />
      </div>

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
